import { useEffect, useState } from "react";
import { ImgUrl } from "../../services/InstanceAxios";
import Images from "../../constant/Images";
import { useNavigate } from "react-router-dom";
import AddStopsComponent from "../../component/places/modal/AddStopsComponent";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../store/app/store";
import {
  getsingleTourSlice,
  setStopDetails,
} from "../../store/features/singleTourSlice";
import EditStopDetails from "../../component/places/modal/EditStopDetails";
import DeleteModalComponent from "../../component/places/modal/DeleteModalComponent";
import services from "../../services/services";
import { toast } from "react-toastify";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ReactQuill from "react-quill";
import StopDetails from "../stopDetails/StopDetails";
import { getTourDescription, getTourName } from "../../services/Tour";

const StopList = (bundle: any) => {
  const dispatch: any = useAppDispatch();
  const navigate = useNavigate();
  const tours = useSelector((state: any) => state.singleTourSlice);
  const [elm, setElm] = useState<any>({});
  const [showEditModal, setShowEditModal] = useState<boolean>(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showList, setShowList] = useState<any>({});
  const [tourDetails, setTourDetails] = useState<any[]>([]);
  const sortedTourDetails = tourDetails
    .slice()
    .sort((a: any, b: any) => a.id - b.id);
  const handleShowMore = (index: any) => {
    if (showList[index]) {
      setShowList({});
    } else {
      setShowList({
        [index]: true,
      });
    }
  };

  useEffect(() => {
    dispatch(getsingleTourSlice(tours?.tour?.id));
  }, []);

  useEffect(() => {
    if (tours?.data?.tourPointsDetail) {
      setTourDetails(tours?.data?.tourPointsDetail);
    }
  }, [tours?.data?.tourPointsDetail]);

  const handleNavigate = (data: any) => {
    if (data == "AddSaftyInformation") {
      navigate("/addSaftyInformation");
    } else {
      dispatch(setStopDetails(data));
      navigate("/stopDetails");
    }
  };
  const handleSaveData = async () => {
    const res: any = await services.editStopList(tourDetails);
    // Your logic to save the data goes here
    // Once the data is saved successfully, set showSuccessMessage to true
    toast.success("Stops saved successfully");
  };

  // Update-publish progress (CR-8): the Update publish alone never rebuilds the
  // route file, so a moved stop used to ship fresh markers over stale geometry
  // to every device (UPD-07). The button now runs two steps in order — 1)
  // regenerate the route from the CURRENT stops, 2) publish — and nothing is
  // published if step 1 fails.
  const [publishState, setPublishState] = useState<null | {
    stage: 1 | 2 | 3; // 1 = regenerating route, 2 = publishing, 3 = done
    error?: string;
  }>(null);

  const handleUpdatePress = async () => {
    const tourId = tours?.tour?.id;
    if (!tourId || (publishState && !publishState.error)) return;
    toast.dismiss();
    setPublishState({ stage: 1 });
    try {
      const routeRes: any = await services.getTourSave({ tourId });
      if (routeRes?.data?.success === false) {
        throw new Error(routeRes?.data?.message || "Route generation failed");
      }
    } catch (error: any) {
      setPublishState({
        stage: 1,
        error:
          error?.response?.data?.message ||
          "Route regeneration failed — nothing was published. Users still see the previous version. Check the stops and try again.",
      });
      return;
    }
    setPublishState({ stage: 2 });
    try {
      await services.updateOffline(tourId);
    } catch (error: any) {
      setPublishState({
        stage: 2,
        error:
          error?.response?.data?.message ||
          "The route was refreshed but the tour update was not announced. Press Update again.",
      });
      return;
    }
    setPublishState({ stage: 3 });
    toast.success("Route regenerated + tour update published");
    setTimeout(() => setPublishState(null), 2500);
  };
  //dispatch(getsingleTourSlice(stop?.id));
  const deleteTour = async (id: any, tourId: any) => {
    const res: any = await services.deleteStop(id);
    if (res?.status == 200) {
      toast.dismiss();
      toast.success(res?.data.message);
      dispatch(getsingleTourSlice(tours?.tour?.id));
    } else {
      toast.error("SomeThing went wrong");
    }
  };

  const handleDragEnd = (result: any) => {
    if (!result.destination) {
      return;
    }

    const startIndex = result.source.index;
    const endIndex = result.destination.index;

    const updatedSortedTourDetails: any = [];
    // Move the data of elements based on the direction
    if (startIndex < endIndex) {
      for (let i = 0; i < startIndex; i++) {
        updatedSortedTourDetails.push(tourDetails[i]);
      }
      var temp = tourDetails[startIndex].id;
      var startElement = JSON.parse(JSON.stringify(tourDetails[startIndex]));
      startElement.id = tourDetails[endIndex].id;
      for (let i = startIndex + 1; i <= endIndex; i++) {
        const temp1 = tourDetails[i].id;
        var element = JSON.parse(JSON.stringify(tourDetails[i]));
        element.id = temp;
        temp = temp1;
        updatedSortedTourDetails.push(element); //tourDetail[i]
      }

      updatedSortedTourDetails.push(startElement); //tourDetail[i]
      for (let i = endIndex + 1; i < tourDetails.length; i++) {
        updatedSortedTourDetails.push(tourDetails[i]);
      }
    } else {
      for (let i = 0; i < endIndex; i++) {
        updatedSortedTourDetails.push(tourDetails[i]);
      }
      var startElement = JSON.parse(JSON.stringify(tourDetails[startIndex]));
      startElement.id = tourDetails[endIndex].id;
      updatedSortedTourDetails.push(startElement); //tourDetail[i]

      for (let i = endIndex; i < startIndex; i++) {
        var element = JSON.parse(JSON.stringify(tourDetails[i]));
        element.id = tourDetails[i + 1].id;
        updatedSortedTourDetails.push(element); //tourDetail[i]
      }

      for (let i = startIndex + 1; i < tourDetails.length; i++) {
        updatedSortedTourDetails.push(tourDetails[i]);
      }
    }
    // Update the state with the new sorted and updated elements
    setTourDetails(updatedSortedTourDetails);
  };

  const getdata = async () => {
    try {
      const res = await services.getSingleTourDirection({
        tourId: tours?.tour?.id,
      });
    } catch (err) {}
  };

  return (
    <div className="w-full px-12 py-6">
      {publishState && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-white rounded-2xl p-8 w-[440px] shadow-xl">
            <p className="text-blue font-roboto font-bold text-lg mb-2">
              {publishState.error
                ? "Update failed"
                : publishState.stage === 1
                ? "Step 1 of 2 — Regenerating route"
                : publishState.stage === 2
                ? "Step 2 of 2 — Publishing tour"
                : "Published"}
            </p>
            <p className="text-sm font-roboto text-lightgray mb-5">
              {publishState.error
                ? publishState.error
                : publishState.stage === 1
                ? "Rebuilding the walking route from the current stops so the map matches them. Large tours can take up to 2 minutes — keep this tab open."
                : publishState.stage === 2
                ? "Announcing the update and publishing the tour details file."
                : "Route and tour details are in sync. Devices will pick up the update."}
            </p>
            <div className="w-full h-2 rounded-full bg-lightblue overflow-hidden">
              <div
                className={`h-2 rounded-full transition-all duration-700 ${
                  publishState.error ? "bg-red-500" : "bg-aqua"
                } ${!publishState.error && publishState.stage !== 3 ? "animate-pulse" : ""}`}
                style={{
                  width: publishState.error
                    ? "100%"
                    : publishState.stage === 1
                    ? "45%"
                    : publishState.stage === 2
                    ? "85%"
                    : "100%",
                }}
              />
            </div>
            {publishState.error && (
              <div className="flex justify-end mt-5">
                <button
                  className="bg-blue text-white rounded-full py-2 px-6 font-roboto"
                  type="button"
                  onClick={() => setPublishState(null)}
                >
                  Close
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      <div className="flex  w-full justify-between items-center">
        <div className="w-2/4">
          <p className="text-blue font-roboto font-bold text-xl">
            {/* {tours?.tour?.name} */}
            {getTourName(tours?.tour?.name, "en")}
          </p>
        </div>
        <div className="flex w-3/4 justify-end mr-4">
          <AddStopsComponent Tour={tours?.tour} />

          <button
            className="bg-aqua text-white rounded-full py-3.5 px-6 font-roboto font-normal xl:py-2 ml-4 hover:bg-blue"
            type="button"
            onClick={() => navigate("/tourImport")}
          >
            Bulk Upload Stops
          </button>
          <button
            className="bg-blue text-white rounded-full py-3.5 px-6 font-roboto font-normal xl:py-2 ml-4"
            onClick={handleNavigate.bind(this, "AddSaftyInformation")}
          >
            Add Saftey Information
          </button>
          <button
            className="bg-blue text-white rounded-full py-3.5 px-6 font-roboto font-normal xl:py-2 ml-4"
            type="button"
            onClick={async () => {
              handleSaveData();
              await services?.getTourSave({ tourId: tours?.tour?.id });
              getdata();
            }}
          >
            Save
          </button>
          <button
            className="bg-aqua text-white rounded-full py-3.5 px-6 font-roboto font-normal xl:py-2 ml-4 hover:bg-blue active:bg-blue disabled:opacity-60"
            type="button"
            disabled={!!publishState && !publishState.error}
            onClick={handleUpdatePress}
          >
            Update
          </button>
        </div>
      </div>
      <DragDropContext onDragEnd={handleDragEnd}>
        <div className="">
          <Droppable droppableId="tourPoints">
            {(provided) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                {sortedTourDetails?.map((elm: any, index: number) => (
                  <Draggable
                    key={elm.id}
                    draggableId={elm.id.toString()}
                    index={index}
                  >
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className="mt-10"
                      >
                        <div
                          className="mt-10 flex items-center border border-aqua rounded-b-2xl"
                          key={index}
                        >
                          <img
                            className="rounded-2xl h-[173px] mr-4"
                            src={
                              elm?.thumbnailUrl
                                ? ImgUrl +
                                  elm?.thumbnailUrl.replace(
                                    /\/root\/imageUpload\//g,
                                    ""
                                  )
                                : Images.noImage
                            }
                            alt="Sunset in the mountains"
                          />
                          <div className="px-4 py-2.5 max-h-[200px] min-h-[200px] w-full flex flex-col justify-between">
                            <div className="flex justify-between w-full">
                              <p className="text-xl text-blue font-roboto font-bold w-[80%] break-words">
                                {getTourName(elm?.name, "en")}
                              </p>
                              <div className="flex">
                                <div>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setElm(elm);
                                      setShowEditModal(true);
                                    }}
                                  >
                                    <img src={Images.edit} alt="edit-icon" />
                                  </button>
                                </div>
                                <div>
                                  <DeleteModalComponent
                                    dlFn={() => {
                                      deleteTour(elm?.id, elm?.tourId);
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                            <p
                              className={`text-black w-full font-ProximaNovaAltRgRegular ${
                                showList ? "h-auto" : "h-auto"
                              } font-normal text-lg xl:text-sm`}
                            >
                              <ReactQuill
                                modules={{
                                  toolbar: false,
                                }}
                                // value={elm?.discription || ""} // Provide a default value to handle possible undefined
                                value={getTourDescription(
                                  elm?.discription,
                                  "en"
                                )}
                                readOnly={true}
                              />
                            </p>
                            <p>Longitude: {elm?.longitude}</p>
                            <p>Latitude: {elm?.lattitude}</p>
                            <p>Radius: {elm?.radius}</p>
                            <div>
                              <button
                                className="bg-aqua text-white rounded-full py-3.5 px-9 font-roboto font-normal xl:py-2.5  ml-1"
                                onClick={handleNavigate.bind(this, elm)}
                              >
                                Learn more
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </div>
      </DragDropContext>
      {showEditModal ? (
        <EditStopDetails
          stop={elm}
          visible={showEditModal}
          onClose={() => setShowEditModal(false)}
        />
      ) : null}
    </div>
  );
};

export default StopList;
